<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="学员反馈列表">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="name"
              placeholder="search by name"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <!--          <div class="flex xs12 sm6">-->
          <!--            <div class="d-flex justify&#45;&#45;end">-->
          <!--              <va-button color="info" small :to="{ name: 'saveFeedback' }">新增学员反馈</va-button>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <va-data-table
          :fields="fields"
          :data="filteredData"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listFeedback"
          api-mode
        >
          <template slot="actions" slot-scope="props">
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id"/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除学员反馈"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import feedbackApi from '../../api/feedback'

export default {
  data () {
    return {
      message: ['Required field'],
      feedbacks: [],
      name: '',
      loading: true,
      pageSize: 10,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'name',
          title: '姓名',
          width: '15%',
        },
        {
          name: 'email',
          title: '邮箱',
          width: '15%',
        },
        {
          name: 'wechat',
          title: '微信号',
          width: '15%',
        },
        {
          name: 'question',
          title: '问题',
          width: '35%',
        },
        {
          name: 'createTime',
          title: '反馈时间',
          width: '15%',
        },
        {
          name: '__slot:actions',
          width: '10%',
          dataClass: 'text-left',
        },
      ]
    },
    filteredData () {
      if (!this.name || this.name.length < 1) {
        return this.feedbacks
      }
      return this.feedbacks.filter(item => {
        return item.name.toLowerCase().startsWith(this.name.toLowerCase())
      })
    },
  },
  created () {
    this.listFeedback()
  },
  methods: {
    listFeedback (pageNumber = 1) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      }
      feedbackApi.listFeedback(params)
        .then(response => {
          this.feedbacks = response.feedbacks
          this.totalPages = response.totalPage
          this.loading = false
        })
    },
    confirmDelete() {
      console.log(this.deleteId)
      if (this.deleteId === null) return
      feedbackApi.deleteFeedback(this.deleteId).then(response => {
        if (response.success === true) {
          this.listFeedback()
        }
      }).catch(error => alert(error))
    },
    search: debounce(function (name) {
      this.name = name
    }, 400),
  },
}

</script>
